import { UzairCoreApiService } from '@/modules/uzair_v2/services/uzairCoreApi.service';

export default class ChatsServices extends UzairCoreApiService {
  async list(query = {}) {
    this.url = 'v1/chats';
    this.params = query;
    const response = await this.get();
    return response.result;
  }

  async streamChat(prompt, handleChunk, activeChatId, activeAbortController) {
    this.url = 'v1/chats';
    this.payload = {
      prompt,
      chat_id: activeChatId,
    };

    const response = await this.stream({
      signal: activeAbortController.signal,
    });
    const reader = response.getReader();
    const decoder = new TextDecoder('utf-8');

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      const chunk = decoder.decode(value, { stream: true });

      handleChunk(chunk);
    }

    return true;
  }

  async getChatMessages(chatId, query) {
    this.url = `v1/chats/${chatId}/messages`;
    this.params = query;
    const response = await this.get();
    return response.result;
  }

  async deleteChatById(chatId) {
    this.url = `v1/chats/${chatId}`;
    const response = await this.delete();
    return response.result;
  }


  async getMessageDetail(messageId) {
    this.url = `v1/chats/messages/${messageId}/analysis`;
    const { result: { data } } = await this.post();
    return data;
  }

  async getMessage(messageId) {
    this.url = `v1/chats/messages/${messageId}`;
    const { result: { data } } = await this.get();
    return data;
  }

  async makeAction(messageId, actionName) {
    this.url = `v1/chats/messages/${messageId}/actions/${actionName}`;
    const { result: { data } } = await this.post();
    return data;
  }
}
